<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loading" />
      <b-row>
        <b-col cols="8">
          <h3 class="mb-28">الإحصائيات</h3>
          <hr />
          <div
            v-for="statistic in statisticsData"
            :key="statistic.mode"
            class="statistic-item my-1"
          >
            <b-media class="align-items-center" no-body>
              <b-media-aside>
                <b-avatar rounded size="60" :variant="statistic.avatarVariant">
                  <span style="font-size: 16px">{{ statistic.value }}</span>
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h4 class="statistic-title">
                  {{ statistic.mode }}
                </h4>
              </b-media-body>
            </b-media>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="d-flex w-100 justify-content-between align-items-center">
            <h3><feather-icon size="22" icon="ClockIcon" /> سجل التتبع</h3>
            <b-button
              v-if="logItems.length> 5"
              variant="flat-info"
              @click="$router.push({ name: 'ministry-dashboard-events-log' })"
              >عرض الكل</b-button
            >
          </div>
          <hr />
          <events-log :events="logItems" />
        </b-col>
      </b-row>
    </div>
    <!-- TransactionsStatistics -->
    <b-modal
      v-model="isTransactionsStatisticsShow"
      centered
      title="عدد المعاملات لديك"
      footer-class="removed"
      class="edit-modal"
      cancel-variant="outline-secondary"
      size="lg"
      no-close-on-backdrop
    >
      <div class="">

        <b-tabs content-class="mt-1">
          <div v-if="loading">

            <b-skeleton v-for="i in 5" :key="i" width="80%" height="25px"></b-skeleton>
          </div>
          <div v-else>
            <b-tab   v-for="(role , i) in options" :key="i" :title="role.text">
              <div v-for="(value, key) in TransactionsStatistics" :key="key"  v-if="role.id == key">

                <ul>
                  <li v-for="(num, type) in value" :key="type"  v-if="type !== 'transaction_role_id'">
                     <!-- <p >{{ value }}</p> -->
                     <h5 >{{ nameOfType(type) }} : <span style="color: #048042;">{{num}}</span></h5>
                  </li>
                </ul>
              </div>
            </b-tab>

          </div>
        </b-tabs>
        <hr />
        <div class="d-flex justify-content-end">

          <b-button variant="secondary" @click="onClickedCancel"> إلغاء </b-button>
        </div>
      </div>
    </b-modal>

    <!-- /TransactionsStatistics -->
  </b-card>
</template>

<script>
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import EventsLog from "@/components/log-timeline";
import {
  BRow,
  BContainer,
  BCol,
  BListGroup,
  BListGroupItem,
  BMedia,
  BMediaAside,
  BMediaBody,
  BAvatar,
  BCard,
  BButton,
  BModal ,
  BTabs ,
  BTab ,
  BSkeleton
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import authHelpers from "@/utils/auth-helpers";

export default {
  components: {
    EventsLog,
    BRow,
    BContainer,
    BCol,
    BListGroup,
    BListGroupItem,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BCard,
    LoadingOverlay,
    BButton ,
    BModal ,
    BTabs ,
    BTab ,
    BSkeleton
  },
  data() {
    return {
      isTransactionsStatisticsShow: false ,
      listOptions : [],
      statisticsData: [
        {
          mode: "منظمة فاعلة",
          types: "good",
          avatar: "HomeIcon",
          avatarVariant: "light-primary",
          value: 0,
          deduction: true,
        },
        // {
        //   mode: "منظمة متوقفة",
        //   avatar: "PackageIcon",
        //   avatarVariant: "light-info",
        //   value: 0,
        //   deduction: false,
        // },
        // {
        //   mode: "طلبات تأسيس",
        //   avatar: "DollarSignIcon",
        //   avatarVariant: "light-success",
        //   value: 0,
        //   deduction: true,
        // },
        // {
        //   mode: "طلب لم يتم الرد عليه",
        //   avatar: "PhoneCallIcon",
        //   avatarVariant: "light-info",
        //   value: 0,
        //   deduction: false,
        // },
      ],
    };
  },
  methods: {
    ...mapActions("Ministry/Dashboard", ["fetchDashboardData" , "fetchTransactionsStatistics"]),
    onClickedCancel(){
      localStorage.removeItem('fromLogin');
      this.isTransactionsStatisticsShow = false
    },

    nameOfType(type){
      if(type == 'count_of_transactions_assigned_to_him'){
        return 'بحاجة معالجة'
      }
      else if(type == 'count_of_transactions_need_review'){
        return 'بحاجة استدراك'
      }
      else if(type == 'count_of_transactions_processed_by_him'){
        return 'المعُالجة'
      }
      else{
        return type
      }
    }

  },
  computed: {
    ...mapGetters("Ministry/Dashboard", ["statistics", "logItems", "loading" , "TransactionsStatistics"]),
    options() {
      if(authHelpers.getTransactionRoles().some(item => item.slug === "employee")  ){
        this.listOptions.push({ text: "موظف", value: "employee" , id :authHelpers.getTransactionRoles().find(item => item.slug === "employee").id })
      }
      if(authHelpers.getTransactionRoles().some(item => item.slug === "head_of_ngo_department")){
        this.listOptions.push({ text: "رئيس دائرة المنظمات غير الحكومية", value: "head_of_ngo_department" , id :authHelpers.getTransactionRoles().find(item => item.slug === "head_of_ngo_department").id  })
      }
      if (authHelpers.getTransactionRoles().some(item => item.slug === "director_of_social_affairs_and_labor")){
        this.listOptions.push({ text: "مدير الشؤون الاجتماعية والعمل", value: "director_of_social_affairs_and_labor" , id :authHelpers.getTransactionRoles().find(item => item.slug === "director_of_social_affairs_and_labor").id  })
      }
      if(authHelpers.getTransactionRoles().some(item => item.slug === "central_employee")){
        this.listOptions.push({ text: 'موظف مركزي', value: "central_employee" , id :authHelpers.getTransactionRoles().find(item => item.slug === "central_employee").id })
      }
      if(authHelpers.getTransactionRoles().some(item => item.slug === "head_of_regulation_and_governance"))
      {
        this.listOptions.push({ text: "رئيس دائرة مركزي", value: "head_of_regulation_and_governance" , id :authHelpers.getTransactionRoles().find(item => item.slug === "head_of_regulation_and_governance").id   })
      }
      if(authHelpers.getTransactionRoles().some(item => item.slug === "director_of_ngos")){
        this.listOptions.push({ text: 'مدير المنظمات غير الحكومية', value: "director_of_ngos" , id :authHelpers.getTransactionRoles().find(item => item.slug === "director_of_ngos").id })
      }

      return this.listOptions  ;
    }
  },

  async created() {
    await this.fetchDashboardData();
    await this.fetchTransactionsStatistics();
    this.statisticsData[0].value = this.statistics.A_ngos_count;
    // this.statisticsData[1].value = this.statistics.C_ngos_count;
    // this.statisticsData[2].value = this.statistics.est_requests_count;
    // this.statisticsData[3].value = this.statistics.est_unchecked_requests_count;

  },
  mounted(){

    // this.isTransactionsStatisticsShow = !(localStorage.getItem('fromLogin') === "false") || false
      if(authHelpers.getTransactionRoles() == undefined || authHelpers.getTransactionRoles().length === 0 || localStorage.getItem('fromLogin')=== null){
        this.isTransactionsStatisticsShow = false
      }
      else{
        this.isTransactionsStatisticsShow = !(localStorage.getItem('fromLogin') === "false") || false
      }
  }
};
</script>
<style>
.mb-28{
  margin-bottom: 28px;
}
</style>
